<div class="col-md-6">
  <label class="form-label">Razao social</label>
  <input
    class="form-control"
    name="razaoSocial"
    [(ngModel)]="empregador.razaoSocial"
    (ngModelChange)="emitirAlteracao()"
    required>
</div>
<div class="col-md-6">
  <label class="form-label">Nome fantasia</label>
  <input
    class="form-control"
    name="nomeFantasia"
    [(ngModel)]="empregador.nomeFantasia"
    (ngModelChange)="emitirAlteracao()">
</div>
<div class="col-md-4">
  <label class="form-label">CNPJ/CPF</label>
  <input
    class="form-control"
    name="documento"
    [(ngModel)]="empregador.documento"
    (ngModelChange)="emitirAlteracao()"
    required>
</div>
<div class="col-md-4">
  <label class="form-label">Cidade</label>
  <input
    class="form-control"
    name="cidade"
    [(ngModel)]="empregador.cidade"
    (ngModelChange)="emitirAlteracao()">
</div>
<div class="col-md-2">
  <label class="form-label">UF</label>
  <input
    class="form-control"
    name="uf"
    [(ngModel)]="empregador.uf"
    (ngModelChange)="emitirAlteracao()"
    maxlength="2">
</div>
<div class="col-md-2 d-flex align-items-end">
  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      name="ativoEmpregador"
      [(ngModel)]="empregador.ativo"
      (ngModelChange)="emitirAlteracao()">
    <label class="form-check-label">Ativo</label>
  </div>
</div>
<div class="col-12">
  <label class="form-label">Endereco</label>
  <input
    class="form-control"
    name="endereco"
    [(ngModel)]="empregador.endereco"
    (ngModelChange)="emitirAlteracao()">
</div>
<div class="col-md-4">
  <label class="form-label">Nome do tenant</label>
  <input
    class="form-control"
    name="slugTenant"
    [ngModel]="empregador.slugTenant"
    (ngModelChange)="tenantChange.emit($event)"
    placeholder="castelandia"
    required>
</div>
<div class="col-md-8">
  <label class="form-label">URL do terminal de ponto</label>
  <input class="form-control" [value]="urlTerminal" readonly>
</div>
<div class="col-md-4">
  <label class="form-label" for="modoApiLeitor">API do leitor facial</label>
  <select
    class="form-select"
    id="modoApiLeitor"
    name="modoApiLeitor"
    [(ngModel)]="empregador.modoApiLeitor"
    (ngModelChange)="emitirAlteracao()">
    <option value="LOCAL">Local (rede interna)</option>
    <option value="EXTERNO">Externo (jwmtecnologia.com.br)</option>
  </select>
</div>
<div class="col-md-8" *ngIf="modoLocal">
  <label class="form-label" for="urlApiLocalLeitor">URL local do JWM</label>
  <input
    class="form-control"
    id="urlApiLocalLeitor"
    name="urlApiLocalLeitor"
    [(ngModel)]="empregador.urlApiLocalLeitor"
    (ngModelChange)="emitirAlteracao()"
    placeholder="http://192.168.0.10:8080"
    required>
  <div class="form-text">
    IP da maquina que roda o backend na mesma rede do iD Face. No navegador deste PC, localhost testa. No aparelho, use o IP LAN (ex. http://192.168.0.10:8080).
  </div>
  <div class="alert alert-warning py-2 mt-2 mb-0" *ngIf="urlLocalEhLoopback">
    localhost/127.0.0.1 so responde neste computador. O iD Face em 192.168.0.55 nao alcança esse endereço.
  </div>
</div>
<div class="col-md-5" *ngIf="!modoLocal">
  <label class="form-label" for="ipApiLeitor">IP publico para o iD Face</label>
  <input
    class="form-control"
    id="ipApiLeitor"
    name="ipApiLeitor"
    [(ngModel)]="empregador.ipApiLeitor"
    (ngModelChange)="emitirAlteracao()"
    placeholder="78.142.242.242"
    required>
</div>
<div class="col-md-3" *ngIf="!modoLocal">
  <label class="form-label" for="portaApiLeitor">Porta publica</label>
  <input
    class="form-control"
    id="portaApiLeitor"
    name="portaApiLeitor"
    type="number"
    min="1"
    max="65535"
    [(ngModel)]="empregador.portaApiLeitor"
    (ngModelChange)="emitirAlteracao()"
    placeholder="4083"
    required>
</div>
<div class="col-12" *ngIf="modoLocal">
  <label class="form-label">URL para o iD Face</label>
  <input class="form-control" [value]="urlTesteNavegador" readonly>
  <div class="form-text">
    No iD Face (Conectividade) use o IP da LAN, porta <code>8080</code> e caminho
    <code>{{ caminhoIdFace || 'api/public/tenants/.../controlid' }}</code>.
    Nao use localhost no aparelho.
    Para a auditoria mostrar a foto da batida, no Monitor do iD Face ligue o envio de imagens.
  </div>
</div>
<div class="col-12" *ngIf="!modoLocal">
  <div class="form-text">
    O iD Face (Conectividade) aceita so IPv4, nao dominio nem <code>https://</code>.
    Hostname/IP: <code>{{ empregador.ipApiLeitor || '78.142.242.242' }}</code>,
    porta: <code>{{ empregador.portaApiLeitor || 4083 }}</code>,
    caminho: <code>{{ caminhoIdFace || 'api/public/tenants/.../controlid' }}</code>
    <span *ngIf="destinoIdFace"> ({{ destinoIdFace }})</span>.
    Teste no navegador (nao copie isso no aparelho):
    <code>{{ urlTesteNavegador }}/session_is_valid.fcgi</code>.
    Para a auditoria mostrar a foto da batida, no Monitor do iD Face ligue o envio de imagens.
  </div>
</div>
<div class="col-12">
  <div class="camera-box">
    <div class="row g-3 align-items-center">
      <div class="col-md-8">
        <label class="form-label">Logo do empregador</label>
        <input class="form-control" type="file" accept="image/*" (change)="carregarLogo.emit($event)">
      </div>
      <div class="col-md-4 d-flex align-items-center justify-content-md-end gap-3">
        <img *ngIf="empregador.logoBase64" class="logo-preview" [src]="empregador.logoBase64" alt="Logo cadastrada">
        <button
          *ngIf="empregador.logoBase64"
          type="button"
          class="btn btn-outline-secondary"
          (click)="removerLogo.emit()">
          Remover logo
        </button>
      </div>
    </div>
  </div>
</div>
